import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { PayeeCasesService } from '../payee-cases.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'payee-case-reference-id-filter',
  templateUrl: './case-reference-id-filter.component.html',
  styleUrls: ['./case-reference-id-filter.component.scss']
})
export class CaseReferenceIdFilterComponent implements OnInit, OnDestroy {
  private readonly destroy = new Subject<void>();
  readonly caseIdControl = new FormControl('', [
    Validators.required,
    Validators.minLength(3)
  ]);

  dropdownOpen = false;

  get selected() {
    return this.payeeCasesService.payee_case_reference_id.value;
  }

  constructor(
    private payeeCasesService: PayeeCasesService,
  ) { }

  ngOnInit(): void {
    this.payeeCasesService.payee_case_reference_id
      .pipe(takeUntil(this.destroy))
      .subscribe(v => this.caseIdControl.patchValue(v));
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }

  applyFilter(): void {
    if (this.caseIdControl.invalid) {
      this.caseIdControl.markAsDirty();
      return;
    }

    this.payeeCasesService.payee_case_reference_id.next(this.caseIdControl.value);
    this.dropdownOpen = false;
  }

  clearFilter(): void {
    this.payeeCasesService.payee_case_reference_id.next(null);
    this.dropdownOpen = false;
  }

  displayWith(selected: string): string {
    return selected;
  }

  onPaste(event: ClipboardEvent): void {
    this.caseIdControl.markAsTouched();
    setTimeout(() => {
      this.applyFilter();
    });
  }
}